export const CONNECTED = 'CONNECTED'
export const DISCONNECTED = 'DISCONNECTED'
export const WARNING = 'WARNING'